import type {SlideItemObject} from '@PosterWhiteboard/items/item/item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';

export function useGetKeyFromActiveSlideItem<T extends keyof SlideItemObject>(key: T): SlideItemObject[T] | undefined | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem?.[key] !== undefined) {
        return slideItem[key];
      }
    }

    return undefined;
  });
}
